import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { clearAllAuthCookies, getCookie } from "shared/auth/utils/cookieUtils";
import { logoutUser } from "shared/api/client/orvalHelpers";

const Logout: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = getCookie("userToken");
    if (!token) {
      clearAllAuthCookies();
      navigate("/login");
      return;
    }

    logoutUser()
      .catch(() => {
        // even if API call fails, proceed with local logout
      })
      .finally(() => {
        clearAllAuthCookies();
        navigate("/login");
      });
  }, [navigate]);

  return <div>Logging out...</div>;
};

export default Logout;
